import { Service } from '@/lib'
import { RestResponse } from '@lounge-fe/network'
import { Customer } from '@shopify/hydrogen-react/storefront-api-types'
import { UpdateAccountDetailsRequest } from './types'

export class AccountDetailsService extends Service {
  get = (): Promise<RestResponse<Customer>> =>
    this.client.get<Customer>('/customer')

  update = (req: UpdateAccountDetailsRequest): Promise<RestResponse> =>
    this.client.put('/customer', req)
}
